<template>
  <div class="main">
    <div class="wrapper">
      <div class="allBox">
        <div
          :style="(index+1)%3==0?'margin-right:0':''"
          class="showBox"
          v-for="(item,index) in zjgwData"
          :key="index"
        >
          <img @click="$router.push(`mzjgwContent/${item.id}`)" :src="item.picture" alt />
          <h3>{{item.title}}</h3>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getLsz } from "@/api/gywm.js";
import { BASE_URL } from "@/utils/base.js";
export default {
  data() {
    return {
      zjgwData: []
    };
  },
  mounted() {
    // window.scrollTo(0, 0);
    this.getData()
  },
  methods: {
    async getData() {
      let news = new FormData();
      news.append("page", 1);
      news.append("rows", 100);
      news.append("dentity", "专家顾问");
      let note = await getLsz(news);
      this.zjgwData= note.rows
      this.zjgwData.map(item=>{
        item.picture=BASE_URL+item.picture;
      })
    }
  },
  components: {
  }
};
</script>
<style lang="less" scoped>
.main {
  margin-top: 10px;
  width: 100%;
  .wrapper {
     width: calc(100vw - 60px);
    margin: 40px auto;
    color: #000;
    .bline {
      width: 100%;
      height: 2px;
      background-color: #f0f0f0;
    }
    .allBox {
      margin-top: 40px;
      display: flex;
      flex-wrap: wrap;

      .showBox {
        width: 160px;
        margin-right: 40px;
        img {
          width: 160px;
          height: 160px;
          cursor: pointer;
        }
        h3 {
          width: 160px;
          text-align: center;
          font-size: 16px;
          line-height: 1.2;
          margin: 20px 0 30px;
        }
      }
    }
  }
}
</style>